import '../../Styles/Layout/MiniUpgradeComponent.css';
import { useWindow } from '../../contexts/WindowContext';
import { useChatContext } from '../../contexts/AppDataContext';
import { TRIAL_DAYS } from '../../Data/PricingData';

const MiniUpgradeComponent = () => {
  const { windowWidth } = useWindow();
  const { setShowSalesModal, setSalesModalFeature } = useChatContext();


  return (
    <div className="upgrade-prompt">
      <div className="upgrade-item">
        <span>You're out of messages for now.</span>
        <button
          type="button"
          onClick={() => {
            setSalesModalFeature('More Messages');
            setShowSalesModal(true);
          }}
          className="upgrade-link"
        >
          {windowWidth > 768 ? `Try a Paid Plan Free for ${TRIAL_DAYS} Days` : 'Upgrade'}
        </button>
      </div>
    </div>
  );
};

export default MiniUpgradeComponent;
